import React from "react";
import { Seo } from "../../shared/Seo";
import styles from "./LegalPage.module.scss";

const SITE_URL = "https://achtungroyale.io";

// Short, plain-language terms of service. Kept deliberately minimal for now —
// revisit once there's a real user base. Not legal advice.
const LAST_UPDATED = "August 31, 2026";
const CONTACT_EMAIL = "hello@achtungroyale.io";

export default function TermsPage() {
  return (
    <>
      <Seo
        title="Terms of Service | Achtung Royale"
        description="Terms of Service for Achtung Royale, the free browser Achtung, die Kurve! game. Fair play rules, account terms, and governing law."
        canonical={`${SITE_URL}/terms`}
      />
      <div className={styles.legal}>
        <p className={styles.updated}>Last updated: {LAST_UPDATED}</p>

        <p>
          Achtung Royale is a free online game. By playing or signing in, you agree to these terms.
        </p>

        <h2>Fair play</h2>
        <ul>
          <li>Don't cheat, use bots, or exploit bugs.</li>
          <li>Don't disrupt the game, its servers, or other players.</li>
          <li>
            Pick a display name that isn't offensive, impersonating, or infringing; we may change
            or remove names that break this.
          </li>
        </ul>
        <p>We may suspend or remove accounts that break these rules.</p>

        <h2>Your account</h2>
        <p>
          You're responsible for what happens under your account. The game, its name, and its
          artwork belong to Achtung Royale.
        </p>

        <h2>Purchases &amp; Golden Eggs</h2>
        <ul>
          <li>
            The shop sells <strong>Golden Eggs</strong>, a virtual currency you can spend on
            cosmetic items. Eggs and cosmetics have no real-world value, are tied to your
            account, and can't be transferred, exchanged, or cashed out.
          </li>
          <li>
            Payments are processed by Stripe. Prices are shown at checkout; your card
            statement will show our company name.
          </li>
          <li>
            Golden Eggs are delivered to your account immediately after payment. By
            purchasing you agree to immediate delivery, which means the EU 14-day right of
            withdrawal no longer applies. Purchases are therefore non-refundable once
            delivered.
          </li>
          <li>
            If a purchase goes wrong (you paid but didn't receive your eggs, or were charged
            twice), email us and we'll make it right. If a payment is refunded or disputed,
            the eggs it bought are removed from the account.
          </li>
          <li>Cosmetics are visual only and never affect gameplay.</li>
        </ul>

        <h2>No warranty</h2>
        <p>
          The game is provided "as is", without warranties, and may change or go offline at any
          time. To the extent permitted by law, we aren't liable for damages arising from your use
          of it.
        </p>

        <h2>Governing law</h2>
        <p>These terms are governed by the laws of Sweden.</p>

        <h2>Changes &amp; contact</h2>
        <p>
          We may update these terms; the date above shows the latest version. Questions? Email{" "}
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
        </p>
      </div>
    </>
  );
}
